import React from "react";
import { useIntl } from "react-intl";
import { PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
export const DemoTitle = () => {
    const intl = useIntl();
    return (React.createElement(PeekStack, null,
        React.createElement(PeekTypography, { variant: "h1", fontWeight: "fontWeightLight" }, intl.formatMessage(messages.aiDiscoverDemoTitle)),
        React.createElement(PeekTypography, { variant: "h4", fontWeight: "fontWeightLight", color: "info.main" }, intl.formatMessage(messages.aiDiscoverDemoSubtitle))));
};
export default DemoTitle;
